import React, { useMemo, useState, createContext, ReactNode } from 'react';

type DataType = {
  showModal: boolean;
};

type MyContextType = {
  data: DataType;
  updateData: (newData: Partial<DataType>) => void; // Specify the type for newData
};

// Default context value
export const MyContext = createContext<MyContextType>({
  data: { showModal: false },
  updateData: () => {}
});

// Define the props for the context provider
type MyContextProviderProps = {
  children: ReactNode; // Specify children prop type
};

export function MyContextProvider({ children }: MyContextProviderProps) {
  const [data, setData] = useState<DataType>({ showModal: false }); // Specify state type

  const updateData = (newData: Partial<DataType>) => {
    // Specify the type for newData
    setData((prevData) => ({ ...prevData, ...newData }));
  };

  const contextValue = useMemo(() => ({ data, updateData }), [data]);

  return <MyContext.Provider value={contextValue}>{children}</MyContext.Provider>;
}
